<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import type {Author} from "~/types/mgnl";
import {useAuthor} from "~/composables/useAuthor";
import {PhArrowRight} from "@phosphor-icons/vue";
import Contact from "~/components/Contact.vue";
import {useModal} from "vue-final-modal";
import {createFunctionalComponent} from "~/utils/createFunctionalComponent";
import {Modal} from "#components";
const props = defineProps<{
  metadata: Area;
  author?: string;
  authorDescription?: string;
  formId?: string;
}>();

const showModal = ref<boolean>(false);
const {t} = useI18n();

const {data: authors, error: authorsError} = await useAsyncData<
  Author[] | undefined
>(props.metadata["@id"] + "_relatedAuthors", () => {
  return props.author ? useAuthor([props.author]) : Promise.resolve(undefined);
});
const openContactForm = (title: string, name: string, email?: string) => {
  if (!props.formId) {
    alert("No form id provided");
    return;
  }
  const PrefilledContact = createFunctionalComponent(Contact, {
    formId: props.formId,
    authorName: name,
    authorEmail: email,
  });

  const {open, close} = useModal({
    component: Modal,
    attrs: {
      eyebrow: t("label.contact"),
      title,
    },
    slots: {
      default: PrefilledContact,
    },
  });
  open();
};
</script>

<template>
  <section
    class="article-read-more_author author flex flex-col gap-16 mb-16"
    v-if="authors && authors.length > 0">
    <h3 class="sr-only">Related author</h3>
    <!-- Start author card -->
    <article
      class="flex flex-col lg:flex-row gap-6"
      v-for="(author, index) in authors">
      <MagnoliaPicture
        :asset="author.authorImage"
        :modifiers="{grayscale: 1}"
        loading="lazy"
        sizes="400 xs:640 lg:280">
      </MagnoliaPicture>
      <div class="article-body flex-1">
        <h1 class="uppercase font-sans font-bold mb-4">
          {{ $t("label.contact") }} {{ author.authorName }}
        </h1>
        <p class="text-width-fit mb-2" v-if="authorDescription">{{ authorDescription }}</p>
        <p class="text-width-fit mb-2" v-else>{{ author.authorDescription }}</p>
        <button
          class="link-with-icon link-underline text-sunrise-200"
          @click="openContactForm(author.authorName, author.authorName)">
          <span>{{ $t("label.contact") }} {{ author.authorName }}</span>
          <PhArrowRight />
        </button>
      </div>
    </article>
    <!-- End author card -->
  </section>
</template>

<style lang="scss" scoped></style>
